import { useCallback, useLayoutEffect, useState } from 'react';

export const useWindowSize = (ref?: HTMLDivElement) => {
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });

  const handleSize = useCallback(() => {
    if (ref) {
      setWindowSize({
        width: ref ? ref.clientWidth : window.innerWidth,
        height: ref ? ref.clientHeight : window.innerHeight
      });
    }
  }, [ref]);

  useLayoutEffect(() => {
    handleSize();

    window.addEventListener('resize', handleSize);

    return () => window.removeEventListener('resize', handleSize);
  }, [handleSize]);

  return windowSize;
};
